export const CONTENT_SOURCE_AUTHORED = 'Authored';
export const TAB_VIDEOS_MAX_RESULTS = 200;

export const queryParams = {
  si: 0,
  content: {
    mr: 5,
    queryType: 'content',
  },
  video: {
    mr: 4,
    queryType: 'video',
  },
};

export const searchQueryMaxLength = 150;
